
enum HeaderEvents {
    ChangeMenu = "[HeaderEvent] ChangeMenu",
    OnScroll = "[HeaderEvent] OnScroll"
}

export default HeaderEvents;
